import { getDeviceId } from '@/Utils/Device';

const appDetails = {
  version: process.env.APP_VERSION,
  name: 'SkyGo web',
};

export function setupSegmentMiddleware(): void {
  if (typeof window === 'undefined') return;
  const analytics = (window as any).analytics;
  if (analytics && typeof analytics.ready === 'function') {
    analytics.ready(() => {
      if (typeof analytics.addSourceMiddleware === 'function') {
        analytics.addSourceMiddleware(({ payload, next }) => {
          payload.obj.context = payload.obj.context || {};
          payload.obj.context.app = {
            ...(payload.obj.context.app || {}),
            ...appDetails,
          };
          payload.obj.context.device = {
            ...(payload.obj.context.device || {}),
            id: getDeviceId(),
          };
          next(payload);
        });
      }
    });
  }
}

export default {
  init: setupSegmentMiddleware,
};
